import { useState } from 'react';
import { Box, Button, Grid, Paper, Step, StepLabel, Stepper } from '@mui/material';
import GridContainer from '@/components/common/elements/GridContainer';
import Text from '@/components/common/elements/Text';
import Terms from './Terms';
import { useNavigate } from 'react-router-dom';

const Signup = () => {
    const navigate = useNavigate();

    return (
        <GridContainer justifyContent="center" alignItems="center">
            <Grid container direction="column" item marginTop="3rem" maxWidth={500}>
                <Text size='2rem' fontweight='bold' textalign='center'>
                    회원가입
                </Text>

                <Stepper activeStep={2} sx={{ marginBottom: '2rem' }}>
                    {['회원 유형 선택', '정보 입력', "완료"].map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                <Paper sx={{ p: 2 }}>
                    <Box display="flex" flexDirection="column" gap={2}>
                        <Text size='1.5rem' fontweight='bold' textalign='center'>
                            회원가입을 축하드립니다.
                        </Text>
                        <Box display="flex" flexDirection="row" gap={2} sx={{ mt: 3, mb: 2 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    navigate('/login');
                                }}
                            >
                                로그인
                            </Button>
                        </Box>
                    </Box>
                </Paper>
            </Grid>
        </GridContainer>
    );
};

export default Signup;
